import React from "react";
import  { useState, useEffect } from 'react';
import SalespersonSidebar from "./SalespersonSidebar";
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import { Checkbox } from '@mui/material';
import './classes/ApprovalProfileChanges.css';

const ApprovalProfileChanges = () => {
   const columns = [   
      {
        field: 'created',
        headerName: 'Created',
        headerClassName: 'super-app-theme--header',
        minWidth: 70, 
        flex:1, 
         sortable: false,
        filterable: false, 
        },
      {
        field: 'type',
        headerName: 'Type',
        headerClassName: 'super-app-theme--header',
        minWidth: 70, 
        flex:1, 
         sortable: false,
        filterable: false, 
        },
      {
        field: 'who',
        headerName: 'Who',
        headerClassName: 'super-app-theme--header',
        minWidth: 70, 
       flex:1,     
        sortable: false,
        filterable: false, // not filterable
        renderCell: (params) => (
          <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.who}
          </Link>
        ),
      },
      {
        field: 'athlete',
        headerName: 'Athlete',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
       flex:1,     
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Link href={params.row.athlete_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.athlete || ''}
          </Link>
        ),
      },
     {
        field: 'show_on_frontend_athlete',
        headerName: 'Show on Frontend Athlete',
        headerClassName: 'super-app-theme--header',
        minWidth: 120, 
        flex:1,
         sortable: false,
        filterable: false,  
         renderCell: (params) => (
        <Checkbox
          checked={params.row.selected}
         
        />
      ),
     },
    {
        field: 'status',
        headerName: 'Status',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
        flex:1,  
         sortable: false,
        filterable: false,
     },
           {
        field: 'operation',
        headerName: 'Operation',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
       flex:1,     
        sortable: false,
        filterable: false,
        renderCell: (params) => (
  params.row.action === 1 && (
    <span>
      <Link
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleAccept(params.row);
        }}
        style={{ color: "#2C99D2", marginRight: '8px' }}
      >
        Accept
      </Link>
      |
      <Link
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleDeny(params.row);
        }}
        style={{ color: "#2C99D2", marginLeft: '8px' }}
      >
        Deny
      </Link>
    </span>
  )
),
      },
    ];
    
    
    
    
    

      /* Pagination, filter config starts here */
    const [rows, setRows] = React.useState([]);
      const [rowCount, setRowCount] = React.useState(0);
      const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
      const [sortModel, setSortModel] = React.useState([]);
      const [filterModel, setFilterModel] = React.useState({ items: [] });
   const [isLoading, setIsLoading] = useState(true);
   const app_url = configData.APP_URL;
    const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
             try {
              setIsLoading(true);
            const response = await fetch(app_url+'profileapproval/profileapprovallist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel
              }),
            });
            const data = await response.json();
            console.log(data.data.rows);
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
            }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
          
       React.useEffect(() => {
         
      
          fetchData();
        }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

        const handleAccept = async (row) => {
   try {
        const response = await fetch(
                app_url+'profileapproval/acceptchanges',
                {
                    method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                uid: row.uid,
                drupal_uid:row.drupal_uid,
                id:row.id
                
              }),
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
              alert(responsedata.data.result);
              fetchData();
            }
             if(responsedata.data.msg == "Error") {
              alert(responsedata.data.result);
              
            }
      } catch (error) {
        console.error('API call failed:', error);
      }
};


  const handleDeny = async (row) => {
  try {
        const response = await fetch(
                app_url+'profileapproval/denychanges',
                {
                    method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                uid: row.uid,
                drupal_uid:row.drupal_uid,
                id:row.id
                
              }),
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
              alert(responsedata.data.result);
              fetchData();
            }
             if(responsedata.data.msg == "Error") {
              alert(responsedata.data.result);
              
            }
      } catch (error) {
        console.error('API call failed:', error);
      }
  };
    return(
        <div id="main">
            <div className="left"></div>
            <div className="center left-center">
                <div className="approvalprofile-container">  
                    <h1>Approval profile changes</h1>                  
                        <div className="approvalprofile-table" style={{ width: '100%',
                                                         
                                                          overflowX: 'clip',    
                                                           }}>
                               
                            
                                                              
                                                                  <DataGrid
                                                                  autoHeight
                                                                  rows={rows}
                                                                  columns={columns.map(col => ({ ...col, filterable: false }))}
                                                                  rowCount={rowCount}
                                                                  getRowHeight={() => 'auto'}
                                                                  paginationMode="server"
                                                                  sortingMode="server"
                                                                  paginationModel={paginationModel}
                                                                  onPaginationModelChange={setPaginationModel}
                                                                  sortModel={sortModel}
                                                                  onSortModelChange={setSortModel}
                                                                  pageSizeOptions={[5, 10, 25, 50]}
                                                                  pageSize={50}
                                                                  getRowId={() => crypto.randomUUID()}
                                                                  disableColumnMenu 
                                                                  sx={{
                                                                    fontFamily: '"Open Sans", sans-serif, Arial, Verdana',
                                                                    '& .MuiDataGrid-row': { marginTop: 1, marginBottom: 1 },
                                                                    '& .coloured': { textAlign: 'center', color: '#7181AD' },
                                                                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'block' },
                                                                    '& .super-app-theme--header': { fontSize: '14px' },
                                                                    '.MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold !important',whiteSpace:'normal' },
                                                                    '& .MuiDataGrid-cell': {
                                                                      whiteSpace: 'normal',
                                                                      wordWrap: 'break-word',
                                                                      lineHeight: '1.4',
                                                                      alignItems: 'center',
                                                                      display: 'flex',
                                                                    },
                                                                    '& .MuiTablePagination-actions': { marginRight: 10 },
                                                                  }}
                                                                />

                    </div>
                </div>
            </div>
            <div className="right">
                <SalespersonSidebar/>
            </div>
        </div>
    );
};
export default ApprovalProfileChanges;